var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"header":_vm.$t('CARD_ENROLL_PASSWORD_RESET_TITLE')}},[_c('b-card-text',[_c('LangTemplate',{attrs:{"path":"CARD_ENROLL_PASSWORD_RESET_DESCRIPTION"}})],1),_c('Route',{staticClass:"btn btn-primary w-100",attrs:{"button":"","route":"/reset/manage"}},[_vm._v(" "+_vm._s(_vm.$t('CARD_ENROLL_PASSWORD_RESET_BUTTON'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }